import { render, staticRenderFns } from "./EmailDeliveryStatusChip.vue?vue&type=template&id=189a18ce"
import script from "./EmailDeliveryStatusChip.vue?vue&type=script&lang=js"
export * from "./EmailDeliveryStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports